/**
 * Created by danielda on 6/16/2015.
 */


define(function (require) {
    "use strict";

    var LE = require("app");
    var RevisionedModel = require("models/RevisionedModel");
    var Config = require("assets/config/entities/config.json");

    var ApiResources = require("assets/data/apiResources.json");

    var MODEL_VALIDATORS = Config.validators.agentGroup;
    var NO_DATA = "noData";

    var KEYS = {
        NAME: "name",
        DESCRIPTION: "description",
        PARENT_GROUP_ID: "parentGroupId",
        ENABLED: "isEnabled",
        MANAGERS: "managers",
        MEMBERS: "members"
    };

    var URL_TYPE = {
        DELETE: "delete",
        GET_USERS: "getUsers",
        UPDATE_USERS: "updateUsers",
        NULL : null
    };

    var AgentGroupModel = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {
        AgentGroupModel = RevisionedModel.extend({
            resource: ApiResources.AccountConfig.AgentGroups,
            MODEL_VALIDATORS: MODEL_VALIDATORS,
            KEYS: KEYS,
            NO_DATA: NO_DATA,
            managersCollection: null,
            membersCollection: null,
            usersCollection: null,
            defaults: {
                id: null,
                name: "",
                parentGroupId: null,
                isEnabled: true,
                managers: [],
                members: []
            },

            saveEnableValidation: {
                name: [
                    {
                        required: true,
                        minLength: 1,
                        msg: "LEUserManagement.agentGroupEdit.errors.name.required"
                    }
                ]
            },

            validation: {
                name: [
                    {
                        required: true,
                        minLength: 1,
                        msg: "LEFramework.entities.userGroup.errors.name.required"
                    },
                    {
                        maxLength: Config.validators.agentGroup.maxNameLength,
                        msg: "LEUserManagement.agentGroupEdit.errors.name.length"
                    }
                ],
                description: {
                    required: false,
                    maxLength: Config.validators.agentGroup.maxDescriptionLength,
                    msg: "LEUserManagement.agentGroupEdit.errors.description.length"
                }
            },
            name: "AgentGroupModel",

            initialize: function(attributes, options) {
                options = options || {};
                this.previousManagers = [];
                this.previousMembers = [];
                this.valueIsChanged = false;
                this.isManagerChange = false;
                this.isMemberChange = false;
                this.subGroups = [];

                RevisionedModel.prototype.initialize.call(this, options);
            },

            _setUrlType: function(urlType) {
                this.urlType = urlType;
            },

            parse: function(response, options){
                if(response && _.isUndefined(response.members)) {
                    response.members = [];
                }
                return RevisionedModel.prototype.parse.call(this, response, options);
            },

            url: function(){
                var url = RevisionedModel.prototype.url.call(this);
                switch (this.urlType) {
                    case URL_TYPE.GET_USERS:
                        return url += "&getUsers=true";
                    case URL_TYPE.UPDATE_USERS:
                        return url += "&updateUsers=true";
                    default:
                        return url;
                }
            },

            fetch: function(options) {
                options = options || {};
                this._setUrlType(URL_TYPE.GET_USERS);
                return RevisionedModel.prototype.fetch.call(this, options);
            },

            save: function(attrs, options) {
                attrs = attrs || null;
                options = options || {};
                if (options.updateUsers) {
                    this._setUrlType(URL_TYPE.UPDATE_USERS);
                }
                else {
                    this._setUrlType(URL_TYPE.NULL);
                }
                return RevisionedModel.prototype.save.call(this, attrs, options);
            },

            destroy: function(options) {
                options = options || {};
                this._setUrlType(URL_TYPE.DELETE);
                return RevisionedModel.prototype.destroy.call(this, options);
            },

            getName: function() {
                return this.get(KEYS.NAME);
            },
            setName: function(name) {
                this.valueIsChanged = true;
                this.set(KEYS.NAME, name);
            },
            getDescription: function() {
                return this.get(KEYS.DESCRIPTION);
            },
            setDescription: function(description) {
                this.valueIsChanged = true;
                this.set(KEYS.DESCRIPTION, description);
            },
            getParentGroupId: function() {
                return this.get(KEYS.PARENT_GROUP_ID);
            },
            setParentGroupId: function(parentGroupId) {
                this.set(KEYS.PARENT_GROUP_ID, parentGroupId);
            },
            getEnabled: function() {
                return this.get(KEYS.ENABLED);
            },
            setEnabled: function(enabled) {
                this.set(KEYS.ENABLED, enabled);
            },
            getManagers: function() {
                return this.get(KEYS.MANAGERS);
            },
            setManagers: function(managers) {
                this.valueIsChanged = true;
                if (!this.isManagerChange){
                    this.previousManagers = this.get(KEYS.MANAGERS);
                    this.isManagerChange = true;
                }

                this.set(KEYS.MANAGERS, managers);
            },
            addManager: function(managerId) {
                var managers = _.clone(this.getManagers());
                managers.push(managerId);
                managers = _.uniq(managers);
                this.setManagers(managers);
            },
            removeManager: function(managerId) {
                var managers = _.clone(this.getManagers());
                var managerIndex = _.indexOf(managers, managerId);
                if (managerIndex > -1) {
                    managers.splice(managerIndex, 1);
                    this.setManagers(managers);
                }
            },
            getMembers: function() {
                return this.get(KEYS.MEMBERS);
            },
            setMembers: function(members) {
                this.valueIsChanged = true;
                if (!this.isMemberChange){
                    this.previousMembers = this.get(KEYS.MEMBERS);
                    this.isMemberChange = true;
                }

                this.set(KEYS.MEMBERS, members);
            },
            addMember: function(memberId) {
                var members = _.clone(this.getMembers());
                members.push(memberId);
                members = _.uniq(members);
                this.setMembers(members);
            },
            removeMember: function(memberId) {
                var members = _.clone(this.getMembers());
                var memberIndex = _.indexOf(members, memberId);
                if (memberIndex > -1) {
                    members.splice(memberIndex, 1);
                    this.setMembers(members);
                }
            },
            getIsManagerChange: function(){
                return this.isManagerChange;
            },
            getIsMemberChange: function(){
                return this.isMemberChange;
            },
            getManagersOrMembersChange: function(){
                return this.getIsMemberChange() || this.getIsManagerChange();
            },
            getPreviousManagers: function(){
                return this.previousManagers;
            },
            getPreviousMembers: function(){
                return this.previousMembers;
            },
            resetSubGroups: function() {
                this.subGroups = [];
                this.trigger("change:subGroups", this.subGroups);
            },
            addSubGroup: function(subGroupId) {
                this.subGroups.push(subGroupId);
                this.subGroups = _.uniq(this.subGroups);
                this.trigger("change:subGroups", this.subGroups);
            },
            removeSubGroup: function(subGroupId) {
                var indexOfSubGroup = this.subGroups.indexOf(subGroupId);
                if (indexOfSubGroup !== -1) {
                    this.subGroups.splice(indexOfSubGroup, 1);
                }
                this.trigger("change:subGroups", this.subGroups);
            },
            getSubGroups: function() {
                return this.subGroups;
            },
            validateSaveEnabled: function () {
                this.originalValidation = this.validation;
                this.validation = this.saveEnableValidation;

                var enable = this.isValid();

                this.validation = this.originalValidation;

                return enable;
            },
            isValueChanged: function() {
                return this.valueIsChanged;
            },
            /**
             * Does the current logged in user have sufficient privileges
             * @param currentPrivileges - Object with specific settings. if the user has privilege to view the entire tree. {viewAll: Boolean}
             * @param groupsUnderLoggedInUser - Ids of groups under the logged in user
             */
            isViewableForLoggedInUser: function(currentPrivileges, groupsUnderLoggedInUser) {
                var isAgentGroupViewable = false;

                // if the logged in user has no specific privilege - he should see all account agent groups
                if (currentPrivileges.viewAll) {
                    isAgentGroupViewable = true;
                }
                else {
                    // otherwise he should see the agent group only if it's under his group tree
                    if (_.contains(groupsUnderLoggedInUser, this.id)) {
                        isAgentGroupViewable = true;
                    }
                }

                return isAgentGroupViewable;
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    AgentGroupModel.NO_DATA = NO_DATA;
    AgentGroupModel.KEYS = KEYS;

    return AgentGroupModel;
});
